
export const startLoading = {
    type: 'loading',
    payload: true
}

export const stopLoading = {
    type: 'loading',
    payload: false
}
